import { useInfiniteQuery } from "react-query";
import { api } from "utils/api";
import type { ReviewResponse, UsersReviewsRequest } from "../types";
import { reviewKeys } from "./queryKeys";

const getUsersReviews = ({
  userId,
  perPage = 10,
  searchAfter,
}: UsersReviewsRequest) => {
  const perPageQuery = `perPage=${perPage}`;
  const searchAfterQuery = searchAfter ? `searchAfter=${searchAfter}` : null;
  const queries = [perPageQuery, searchAfterQuery].filter(Boolean).join("&");

  return api.get<ReviewResponse>(`/users/${userId}/reviews?${queries}`);
};

const useUsersReviews = (params: Omit<UsersReviewsRequest, "searchAfter">) =>
  useInfiniteQuery(
    reviewKeys.usersList(params),
    ({ pageParam }) => getUsersReviews({ searchAfter: pageParam, ...params }),
    {
      getNextPageParam: (lastPage: ReviewResponse) => lastPage.searchAfter,
    }
  );

export { useUsersReviews };
